import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteShell, PageHero } from "@/components/site/SiteShell";
import { Section } from "@/components/site/Blocks";
import { CheckCircle2, ArrowRight } from "lucide-react";

export const Route = createFileRoute("/es/gracias")({
  head: () => ({
    meta: [
      { title: "Gracias — Solicitud Recibida | Simply Approved Mortgages" },
      { name: "description", content: "Hemos recibido su información. Así es lo que sigue y los documentos para reunir mientras nuestro equipo revisa su archivo." },
      { name: "robots", content: "noindex, nofollow" },
    ],
    links: [{ rel: "canonical", href: "/es/gracias" }],
  }),
  component: ThankYouPage,
});

const nextSteps = [
  "Un oficial de préstamos con licencia le llamará o enviará correo en un día hábil.",
  "Recibirá una revisión inicial del escenario cuando tengamos autorización de crédito y sus documentos de respaldo — la cotización formal, LTV, puntos y reservas se emiten tras la suscripción.",
  "Abriremos título, ordenaremos el avalúo y coordinaremos el seguro una vez que avance.",
  "Le enviaremos un enlace seguro para cargar documentos — no necesita enviarlos por correo.",
];

const documents = [
  "Identificación con foto emitida por gobierno para cada prestatario/garante",
  "Dos meses de estados de banca/inversión más recientes (reservas líquidas)",
  "Documentos de la entidad si cierra en LLC/Corp/LP (Artículos, carta EIN, Acuerdo Operativo)",
  "Contrato de compra firmado o estado de cuenta hipotecaria actual (refi)",
  "Factura de impuestos + seguro de la propiedad (o cotización)",
  "Relación de inquilinos / contratos de arrendamiento vigentes (si aplica)",
];

function ThankYouPage() {
  return (
    <SiteShell>
      <PageHero
        eyebrow="Solicitud recibida"
        title="Listo."
        subtitle="Gracias — hemos recibido su información. Revisaremos su presentación y nos comunicaremos con los siguientes pasos para completar su solicitud."
      />
      <Section>
        <div className="mx-auto max-w-3xl space-y-6">
          <div className="rounded-2xl border border-brand-gold/40 bg-brand-gold/10 p-6 text-center">
            <CheckCircle2 className="mx-auto h-10 w-10 text-brand" />
            <p className="mt-2 text-sm text-muted-foreground">Su archivo está en cola y dirigido a nuestro escritorio de préstamos para inversionistas.</p>
          </div>

          <div className="grid gap-6 md:grid-cols-2">
            <div className="rounded-2xl border border-border bg-card p-6">
              <div className="text-[11px] font-black uppercase tracking-widest text-brand">Qué sigue</div>
              <p className="mt-2 text-sm text-muted-foreground">La revisión inicial del escenario es generalmente el mismo día hábil siguiente a la autorización de crédito + documentos.</p>
              <ul className="mt-3 space-y-2 text-sm">
                {nextSteps.map((s, i) => (
                  <li key={i} className="flex gap-2">
                    <ArrowRight className="mt-0.5 h-4 w-4 shrink-0 text-brand" />
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="rounded-2xl border border-border bg-card p-6">
              <div className="text-[11px] font-black uppercase tracking-widest text-brand">Documentos para reunir</div>
              <p className="mt-2 text-sm text-muted-foreground">Le enviaremos un enlace seguro para cargar — no necesita enviarlos por correo.</p>
              <ul className="mt-3 space-y-2 text-sm">
                {documents.map((s, i) => (
                  <li key={i} className="flex gap-2">
                    <CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" />
                    <span>{s}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="rounded-2xl border border-border bg-card p-6 text-sm text-muted-foreground">
            <p>
              ¿Prefiere hablar ahora? Llámenos al{" "}
              <a href="tel:+18778137219" className="font-bold text-brand hover:underline">(877) 813-7219</a>{" "}
              o{" "}
              <Link to="/es/contacto" className="font-bold text-brand hover:underline">envíenos un mensaje</Link>.
            </p>
            <p className="mt-3">
              <Link to="/es" className="font-bold text-brand hover:underline">← Volver al inicio</Link>
            </p>
          </div>
        </div>
      </Section>
    </SiteShell>
  );
}
